import { defineComponent as _defineComponent } from 'vue'
import UserSelect from '@/components/user/Select.vue';
import { Address } from '@/models/Address';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectOwnerDialog',
  props: {
    value: { type: Boolean },
    address: null,
    loading: { type: Boolean },
    context: null
  },
  emits: ['selected'],
  setup(__props: any, { emit }) {





const selectedUser = ref(null);

async function onSave() {
    if (selectedUser.value) {
        emit('selected', selectedUser.value);
    }
}

return { __sfc: true,emit, selectedUser, onSave, UserSelect }
}

})